import React, { useEffect, useState } from "react";

// "changes" reuses the exact rejection flow and payload; only the copy and
// accent colour differ so clients can tell it apart from a hard reject.
const VARIANTS = {
  reject: {
    title: "Reject deliverable",
    description:
      "Let the vendor know what needs to change before this deliverable can be approved.",
    placeholder: "Describe what needs to be revised...",
    submitLabel: "Submit rejection",
    accent: "#d93025",
  },
  changes: {
    title: "Request changes",
    description:
      "Share your feedback with the vendor. They'll revise the deliverable and resubmit it for your review.",
    placeholder: "Describe the changes you'd like...",
    submitLabel: "Send request",
    accent: "#b45309",
  },
};

export default function RejectionModal({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
  variant = "reject",
}) {
  const [comment, setComment] = useState("");
  const copy = VARIANTS[variant] || VARIANTS.reject;

  // Clear any draft once the modal closes (including after a successful
  // submit) so it doesn't leak into the next reject/request-changes.
  useEffect(() => {
    if (!isOpen) setComment("");
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!comment.trim()) return;
    onSubmit(comment.trim());
  };

  const handleClose = () => {
    setComment("");
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#ffffff",
          borderRadius: "12px",
          padding: "24px",
          width: "440px",
          maxWidth: "90vw",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        <div>
          <h3
            style={{
              margin: "0 0 4px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#111827",
            }}
          >
            {copy.title}
          </h3>
          <p style={{ margin: 0, fontSize: "12px", color: "#6b7280" }}>
            {copy.description}
          </p>
        </div>

        <textarea
          required
          rows={4}
          placeholder={copy.placeholder}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          style={{
            width: "100%",
            padding: "10px 12px",
            border: "1px solid #e5e7eb",
            borderRadius: "6px",
            fontSize: "13px",
            color: "#111827",
            resize: "vertical",
            fontFamily: "inherit",
          }}
        />

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <button
            type="button"
            onClick={handleClose}
            disabled={isSubmitting}
            style={{
              background: "transparent",
              border: "none",
              color: "#6b7280",
              padding: "8px 16px",
              fontSize: "13px",
              cursor: isSubmitting ? "not-allowed" : "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSubmitting || !comment.trim()}
            style={{
              background: copy.accent,
              color: "#fff",
              border: "none",
              padding: "8px 20px",
              borderRadius: "6px",
              fontSize: "13px",
              fontWeight: "600",
              cursor:
                isSubmitting || !comment.trim() ? "not-allowed" : "pointer",
              opacity: isSubmitting || !comment.trim() ? 0.6 : 1,
            }}
          >
            {isSubmitting ? "Submitting..." : copy.submitLabel}
          </button>
        </div>
      </form>
    </div>
  );
}
